export class ExpiredRefreshTokenError extends Error {
    constructor(message) {
        super(message);
        this.name = "ExpiredRefreshTokenError";
    }
}